import React, { useCallback, useState } from 'react';
import { NoColorLink } from 'ui/NoColorLink';
import { IconButton, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {
    PatchPayStatePayload,
    PayStateT,
} from 'routes/HumanResourcesModule/PayState/helpers/types';
import { usePatchPayState } from 'routes/HumanResourcesModule/PayState/helpers/hooks/payState';
import EditIcon from '@mui/icons-material/Edit';
import PayStateModal from 'routes/HumanResourcesModule/PayState/PayStateHome/components/PayStateModal/PayStateModal';
import {
    StySynthesisHeader,
    StyName,
} from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/components/SynthesisHeader/StyComponents';
import { HR_HOME_PAGE_URL } from 'components/App/components/routes';

type Props = {
    payState: PayStateT;
};

function SynthesisHeader({ payState }: Props): React.ReactElement {
    const [showPayStateModal, setShowPayStateModal] = useState(false);
    const updatePayStateMutation = usePatchPayState();
    const {
        isPending: isUpdatePayStateLoading,
        isError: isUpdatePayStateError,
    } = updatePayStateMutation;

    const togglePayStateModal = useCallback(() => {
        setShowPayStateModal((current) => !current);
    }, []);

    const onSave = ({ exercice, title }: PatchPayStatePayload) => {
        updatePayStateMutation.mutate({
            id: payState.id,
            exercice,
            title,
        });
    };
    return (
        <StySynthesisHeader>
            <StyName>
                <NoColorLink
                    to={`${HR_HOME_PAGE_URL}/pay_state_home/${payState.exercice}`}
                >
                    <IconButton sx={{ padding: 0 }}>
                        <ArrowBackIosIcon fontSize="small" />
                    </IconButton>
                </NoColorLink>
                <Typography variant="h4" sx={{ display: 'flex' }}>
                    {`${payState.exercice} - ${payState.title}`}
                </Typography>
                <IconButton
                    onClick={togglePayStateModal}
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <EditIcon />
                </IconButton>
            </StyName>

            {showPayStateModal && (
                <PayStateModal
                    onSave={onSave}
                    show={showPayStateModal}
                    editMode
                    onClose={togglePayStateModal}
                    isError={isUpdatePayStateError}
                    payState={payState}
                    currentExercice={payState.exercice}
                    isLoading={isUpdatePayStateLoading}
                />
            )}
        </StySynthesisHeader>
    );
}

export default SynthesisHeader;
